module.exports = __webpack_public_path__ + "img/select-project.aee9dbc7.svg";